import moment from 'moment';
import React from 'react';
import {
  Textbox
} from "react-inputs-validation";
import DatePicker from "react-datepicker";





const TextBox = ({ id,
  type,
  input,
  value,
  valorTipoDocumento,
  name,
  placeholder,
  onChange,
  validationCallback,
  maxLength,
  minLength,
  length,
  required,
  reg,
  mensajeError,
  validate,
  min,
  max,
  valorPadre,
  esDependiente,
  codPadre,
  edadMaxima,
  edadMinima,
  disabled,
  esRuc,
  validacionYup,
  mensajeErrorYup,
  onlyMonth = false,
  mask,
  hasError,
  onBlur
}) => {

  var minAux = (esDependiente && codPadre == "tipoIdentificacion" && valorPadre == "1") ? 10 : esDependiente && codPadre == "tipoIdentificacion" && valorPadre == "2" ? 13 : length
  var typeAux = (esDependiente && codPadre == "tipoIdentificacion" && valorPadre == "1") ? 'number' : esDependiente && codPadre == "tipoIdentificacion" && valorPadre == "2" ? 'number' : esDependiente && codPadre == "tipoIdentificacion" && valorPadre == "3" ? 'alphanumeric' : type
  const specialCharRegex = /[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s&]/;
  const decimalRegex = /^\d+(\.\d{0,2})?$/;

  return (
    <div>




      {
        onlyMonth ?

          <input

            value={value}

            onChange={(valor, e) => {
              console.log('vervalorrrrr',valor.target.value)
              onChange(valor.target.value)
            }}


            className='form form-control' type="month" />
          :
          mask ?
            <div style={{ width: '100%' }}>
              <DatePicker 
                dateFormat="yyyy-MM-dd"
                selected={value ? moment(value, "YYYY-MM-DD").toDate() : null}
                onChange={(date) => onChange(date ? moment(date).format("YYYY-MM-DD") : '')}
                className={`form-control ${hasError ? 'is-invalid' : ''}`} 
                wrapperClassName="w-100 d-block"
                placeholderText={placeholder || 'AAAA-MM-DD'}
                disabled={disabled ? true : (esDependiente && !valorPadre) ? true : false}
                name={name}
                id={id}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                autoComplete="off"
              />
              {(hasError && !validacionYup) && (
                <div className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp' style={{ display: 'block', marginTop: '5px' }}>
                  {mensajeError || 'Este campo es obligatorio'}
                </div>
              )}
            </div>
          :
          <Textbox
            tabIndex="1"
            type={typeAux}
            disabled={
              disabled ? true : (esDependiente && !valorPadre) ? true : false
            }
            value={value}
            name={name}
            id={id}
            classNameInput={"form-control"}
            placeholder={placeholder}
            onChange={(valor, e) => {
              onChange(valor)
            }}
            onBlur={e => {
              if (onBlur) {
                onBlur(e);
              }
            }}
            validate={validate}
            validationCallback={res => {
              validationCallback(res)

            }} // Optional.[Func].Default: none. Return the validation result.
            validationOption={{
              type: type == 'number' ? type : 'string',
              required: validacionYup ? null : required,
              maxlength: validacionYup ? null : maxLength,
              length: validacionYup ? null : minAux,
              reg: validacionYup ? null : reg ? new RegExp(reg) : null,
              min: validacionYup ? null : min,
              max: validacionYup ? null : max,
              //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
              // reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
              msgOnError: validacionYup ? '' :
                type == 'date' && edadMaxima && edadMinima ? `La edad del asegurado debe estar entre los ${edadMinima} y ${edadMaxima} años` : mensajeError,

              customFunc: (res) => {


                if (validacionYup) {
                  return true
                }

                switch (name) {
                  case "nombreAsegurado":
                  case "ruc":
                    if (specialCharRegex.test(res)) {
                      return false;
                    }
                    break;

                  case "valorAsegurado":
                    const decimalRegex = /^\d+(\.\d{0,2})?$/;
                    if (!decimalRegex.test(res)) {
                      return false;
                    }
                    break;

                  default:
                    return true;
                }

                if (type == 'date' && (valorTipoDocumento && valorTipoDocumento.value && valorTipoDocumento.value != '2')) {

                  var diferenciaAnios = moment().diff(new Date(res), 'years');


                  if (edadMaxima && diferenciaAnios > edadMaxima) {
                    return 'Edad incorrecta'
                  } else if (edadMinima && diferenciaAnios < edadMinima) {
                    return 'Edad incorrecta'
                  } else {
                    return true
                  }


                } else {
                  return true
                }
              },
            }}



          />

      }

      {validacionYup &&

        <label className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp'>
          {mensajeErrorYup}
        </label>
      }

    </div>

  );
};

export default TextBox;
